/**
 * in this module there is the function that update the text in the header and the query to use in the report
 */

/**
 * import modules
 */
 import {fromCircle} from 'ol/geom/Polygon'
 import drawing from '../common/drawing'
 /**
  * initialize the events
  */
var pageconfig = JSON.parse($('#pageconfig').val())
let appname = pageconfig.appname.type

 const initAmEvents = (getOverlay) => {
   /**
    * initialize the fixed settings
    * initialize the overlay
    */
    let overlay = getOverlay


   /**
    * report tool
    */
    $('#reportbtn').click(function () {

      // Count nr of Accs
      var nFatal = isNaN(parseInt($('#accs_fatal').text().split(':')[2])) ? 0 : parseInt($('#accs_fatal').text().split(':')[2])
      var nSerious = isNaN(parseInt($('#accs_serious').text().split(':')[2])) ? 0 : parseInt($('#accs_serious').text().split(':')[2])
      var nSlight = isNaN(parseInt($('#accs_slight').text().split(':')[2])) ? 0 : parseInt($('#accs_slight').text().split(':')[2])
      var totalAccs = nFatal + nSerious + nSlight

      $('#totalAccs').text(totalAccs)

      //Display the right message
      if(totalAccs <= 500)
      {
        $("#amReport-body-ok").show()
        $("#amReport-footer-ok").show()
        $("#amReport-body-notok").hide()
        $("#amReport-footer-notok").hide()
      } else {
        $("#amReport-body-ok").hide()
        $("#amReport-footer-ok").hide()
        $("#amReport-body-notok").show()
        $("#amReport-footer-notok").show()
      }

      $('#amReport').modal('show')
   })

  //When user click in the button to generate a polygon
  $('#drawPoly').on('click', function() {
    if (!$('#collapseTwo').hasClass('show')) {
      $('#headingTwo a').click()
    }
    $('#Polygon').trigger('click')
  })

  //When user click in the button to change the filters in the legend
  $('#openLegend').on('click', function() {
    if (!$('#collapseThree').hasClass('show')) {
      $('#headingThree a').click()
    }
  })

  // Run Composite Report
  $('#genCompRep').on('click', function() {
    runReport('composite')
  })

  // Run Summary Report
  $('#genSummRep').on('click', function() {
    runReport('summary')
  })

    //Generate the actual report based in the type passed in
   function runReport(repType) {
    var pUrl = repType

     let polyfilt = ''

     if (pageconfig.draw && $('#fmarkfil').val() === 'on') {
       /**
        * initialize the Dsource
        * create the polygon to pass into the parameter
        */

       let Dsource = drawing.getSource()

       const setCharAt = (str, index, chr) => {
         if (index > str.length - 1) return str
         return str.substr(0, index) + chr + str.substr(index + 1)
       }

       let POLYGON = ''

       // check if the draw was a polygon or a circle and get the correct parameter to send in the request
       if (Dsource.getFeatures()[0].getGeometry().getType() === 'Polygon') {
         POLYGON = Dsource.getFeatures()[0].getGeometry().getCoordinates()
       }
       else {
         POLYGON = fromCircle(Dsource.getFeatures()[0].getGeometry()).getCoordinates()
       }

       // convert the array back from the previous function into a string and remove the unseccessary commas
       POLYGON = POLYGON.toString()
       let allComma = []

       for (let i = 0; i < POLYGON.length; i++) {
         if (POLYGON[i] === ',') allComma.push(i)
       }

       for (let i = 0; i < allComma.length; i++) {
         if (i % 2 === 0) {
           POLYGON = setCharAt(POLYGON, allComma[i], ' ')
         }
       }
       polyfilt = `POLYGON((${POLYGON}))`
     }

     let dAccFrom = $('#fromdate').val().split('/').reverse().join('-')
     let dAccTo = $('#todate').val().split('/').reverse().join('-')
     let sSevSel = $('#rtcfeatclick').val()
     let pdq = $('.pdq_on').attr('data-value')
     let filter = $('#fmarkfil').val()
     let reportCriteria = $('.amdisclaimer .accfiltsel').text().replace('Displaying ', '')
     let url = '/genrep'

      if (pUrl === 'summary') {
        if (filter === 'on') {
          window.open(`${url}?repType=accsmap&dfrom=${dAccFrom}&dto=${dAccTo}&pdq=${pdq}&sev=${sSevSel}&pol=${polyfilt}&criteria=${encodeURIComponent(reportCriteria)}`)
        }
        else {
          window.open(`${url}?repType=accsmap&dfrom=${dAccFrom}&dto=${dAccTo}&pdq=${pdq}&sev=${sSevSel}&pol=&criteria=${encodeURIComponent(reportCriteria)}`)
        }
      }
      else if (pUrl === 'composite') {
        if (filter === 'on') {
          window.open(`${url}?repType=caccsmap&dfrom=${dAccFrom}&dto=${dAccTo}&pdq=${pdq}&sev=${sSevSel}&pol=${polyfilt}&criteria=${encodeURIComponent(reportCriteria)}`)
        }
        else {
          window.open(`${url}?repType=caccsmap&dfrom=${dAccFrom}&dto=${dAccTo}&pdq=${pdq}&sev=${sSevSel}&pol=&criteria=${encodeURIComponent(reportCriteria)}`)
        }
      }
   }
 }
/**
 * update the report parameters
 */

const updateReportParams = () => {
  /**
   * update the report parameters
   */
 if (!pageconfig.report && appname !== 'accsmap') {
    return
 }
  const sDateFrom = $('#fromdate').val()
  const sDateTo = $('#todate').val()

  /**
   * get the selected features and remore the ' from around the severity
   */

  let sSevSel = $('#rtcfeatclick').val().replace(/'/g, '').split(',').join(', ')

  /**
   * create an empty reportCriteria var
   */

  let reportCriteria = ''

  /**
   * check if the severity has at least one element
   */
  if (sSevSel === ' ') {
    reportCriteria = `No collisions displayed`
  }

  else {
    /**
     * check if the filter is ON
     */

    if ($('#fmarkfil').val() === 'on') {
      /**
       * check if the predefined query is the default one
       * append the correct text
       */

      if ($('.pdq_on').attr('data-value') === 'pdq0') {
        reportCriteria = `Displaying ${sSevSel} collisions between ${sDateFrom} and ${sDateTo} filtered by user drawn polygon`
      }
      /**
       * else if it's another query
       * append the correct text
       */

      else {
        reportCriteria = `Displaying ${$('.pdq_on').text()}, ${sSevSel} collisions between ${sDateFrom} and ${sDateTo} filtered by user drawn polygon`
      }
    }

    /**
     * else if the filter is OFF
     */

    else {
      /**
       * check if the predefined query is the default one
       * append the correct text
       */

      if ($('.pdq_on').attr('data-value') === 'pdq0') {
        reportCriteria = `Displaying ${sSevSel} collisions between ${sDateFrom} and ${sDateTo}`
      }

      /**
       * else if it's another query
       * append the correct text
       */

      else {
        reportCriteria = `Displaying ${$('.pdq_on').text()}, ${sSevSel} collisions between ${sDateFrom} and ${sDateTo}`
      }
    }

    /**
     * check if there are predefined query
     * display the correct text
     */

    if ($('#pdq_list').length === 0) {
      reportCriteria = `Displaying collisions between ${sDateFrom} and ${sDateTo}`
    }
  }
  /**
   * display the correct text in the .accfiltsel divs (help and header)
   */

  $('.accfiltsel').text(reportCriteria)
}
/**
 * EXPORT
 */

export default {
  updateReportParams,
  initAmEvents
}
